import React from 'react';

const SimpleFallback = ({ error, errorInfo }) => {
  return (
    <div style={{
      position: 'fixed',
      top: 0,
      left: 0,
      right: 0,
      bottom: 0,
      background: '#000333',
      color: 'white',
      display: 'flex',
      alignItems: 'center',
      justifyContent: 'center',
      flexDirection: 'column',
      padding: '20px',
      fontFamily: 'Arial, sans-serif',
      zIndex: 10000
    }}>
      <h1 style={{ marginBottom: '20px', color: '#ff6b6b' }}>⚠️ Application Error</h1>
      
      <div style={{ 
        background: 'rgba(255,255,255,0.1)', 
        padding: '20px', 
        borderRadius: '8px',
        maxWidth: '600px',
        width: '100%',
        marginBottom: '20px'
      }}>
        <h3>Environment Information:</h3>
        <ul style={{ textAlign: 'left' }}>
          <li>NODE_ENV: {process.env.NODE_ENV}</li>
          <li>SUPABASE_URL: {process.env.REACT_APP_SUPABASE_URL ? '✅ SET' : '❌ MISSING'}</li>
          <li>SUPABASE_KEY: {process.env.REACT_APP_SUPABASE_ANON_KEY ? '✅ SET' : '❌ MISSING'}</li>
          <li>User Agent: {navigator.userAgent.substring(0, 100)}...</li>
          <li>Screen: {window.innerWidth}x{window.innerHeight}</li>
        </ul>
      </div>

      {error && (
        <div style={{ 
          background: 'rgba(255,0,0,0.2)', 
          padding: '15px', 
          borderRadius: '8px',
          maxWidth: '600px',
          width: '100%',
          marginBottom: '20px'
        }}>
          <h3>Error Details:</h3>
          <pre style={{ 
            background: 'rgba(0,0,0,0.5)', 
            padding: '10px', 
            borderRadius: '4px',
            fontSize: '12px',
            overflow: 'auto',
            maxHeight: '200px'
          }}>
            {error.toString()}
          </pre>
        </div>
      )}

      {errorInfo && (
        <div style={{ 
          background: 'rgba(0,0,255,0.2)', 
          padding: '15px', 
          borderRadius: '8px',
          maxWidth: '600px',
          width: '100%'
        }}>
          <h3>Component Stack:</h3>
          <pre style={{ 
            background: 'rgba(0,0,0,0.5)', 
            padding: '10px', 
            borderRadius: '4px',
            fontSize: '12px',
            overflow: 'auto',
            maxHeight: '200px'
          }}>
            {errorInfo.componentStack}
          </pre>
        </div>
      )}

      <div style={{ marginTop: '20px', fontSize: '14px', opacity: 0.8 }}>
        <p>Please check the browser console for additional details.</p>
        <p>If you're a prodactive admin, try pressing Ctrl+Shift+D to access the debug panel.</p>
      </div>
    </div>
  );
};

export default SimpleFallback; 